(function () {
  function fixQuantityDisplay() {
    if (document.getElementById('td3-quantity-number-fix')) return;
    const style = document.createElement('style');
    style.id = 'td3-quantity-number-fix';
    style.textContent = '.product-section .quantity{display:flex!important;align-items:center!important}.product-section .quantity__input{display:block!important;visibility:visible!important;opacity:1!important;color:#fff!important;-webkit-text-fill-color:#fff!important;background:transparent!important;text-align:center!important;flex:1 1 auto!important;width:auto!important;min-width:0!important;font-size:16px!important;font-weight:700!important;line-height:1!important;padding:0!important;margin:0!important}.product-section .quantity__button{flex:0 0 36px!important;width:36px!important}';
    document.head.appendChild(style);
  }

  fixQuantityDisplay();
  document.addEventListener('shopify:section:load', fixQuantityDisplay);

  if (customElements.get('product-form')) return;

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
    }

    connectedCallback() {
      this.addEventListener('submit', this.onSubmitHandler);
      this.ensureVariantInput();
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.onSubmitHandler);
    }

    ensureVariantInput() {
      const form = this.querySelector('form[data-type="add-to-cart-form"]');
      const input = form && form.querySelector('input[name="id"]');
      if (input) input.disabled = false;
    }

    updateCartIcon(sectionHtml) {
      if (!sectionHtml) return;
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (!cartIcon) return;
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const freshIcon = parsed.querySelector('#cart-icon-bubble');
      if (!freshIcon) return;
      const freshCount = freshIcon.querySelector('.cart-count-bubble');
      const currentCount = cartIcon.querySelector('.cart-count-bubble');
      if (freshCount && currentCount) currentCount.innerHTML = freshCount.innerHTML;
      cartIcon.classList.toggle('header__cart--empt', freshIcon.classList.contains('header__cart--empt'));
    }

    refreshCartCount() {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      return fetch(cartUrl + '.js?_td3=' + Date.now(), {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart count request failed');
          return response.json();
        })
        .then((cart) => {
          document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach((bubble) => {
            let visible = bubble.querySelector('span[aria-hidden="true"]');
            if (!visible && cart.item_count < 100) {
              visible = document.createElement('span');
              visible.setAttribute('aria-hidden', 'true');
              bubble.prepend(visible);
            }
            if (visible) visible.textContent = cart.item_count;
            const hidden = bubble.querySelector('.visually-hidden');
            if (hidden) hidden.textContent = cart.item_count + ' Artikel im Warenkorb';
          });
        });
    }

    onSubmitHandler(event) {
      const form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      event.preventDefault();

      const submitButton = form.querySelector('[type="submit"][name="add"]');
      const idInput = form.querySelector('input[name="id"]');
      if (!submitButton || !idInput || !idInput.value) return;
      if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

      idInput.disabled = false;
      this.handleErrorMessage();
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      const spinner = submitButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const formData = new FormData(form);
      formData.delete('sections');
      formData.delete('sections_url');
      formData.append('sections', 'cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || data.status) {
            const message = data.description || data.message || 'Artikel konnte nicht hinzugefügt werden.';
            this.handleErrorMessage(message);
            document.dispatchEvent(new CustomEvent('cart:error', {
              detail: {
                source: this.dataset.source,
                productVariantId: idInput.value,
                errors: message,
                message
              }
            }));
            return;
          }

          if (data.sections && data.sections['cart-icon-bubble']) {
            this.updateCartIcon(data.sections['cart-icon-bubble']);
          }

          this.refreshCartCount().catch(() => {});

          const textEl = submitButton.querySelector('span');
          if (textEl) {
            const oldText = textEl.textContent;
            textEl.textContent = 'Hinzugefügt ✓';
            window.setTimeout(() => { textEl.textContent = oldText; }, 1200);
          }
        })
        .catch((error) => {
          console.error('[3DTools cart]', error);
          this.handleErrorMessage('Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten.');
        })
        .finally(() => {
          const liveButton = form.querySelector('[type="submit"][name="add"]') || submitButton;
          liveButton.removeAttribute('aria-disabled');
          liveButton.classList.remove('loading');
          const liveSpinner = liveButton.querySelector('.loading-overlay__spinner');
          if (liveSpinner) liveSpinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!errorWrapper) return;
      const errorMessageElement = errorWrapper.querySelector('.product-form__error-message');
      errorWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && errorMessageElement) errorMessageElement.textContent = errorMessage;
    }
  }

  customElements.define('product-form', ProductForm);

  document.addEventListener('variant:change', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    const form = document.getElementById('product-form-' + sectionId);
    const input = form && form.querySelector('input[name="id"]');
    if (input) input.disabled = false;
  });
})();